import {
  Color,
  FieldLabel,
  Paragraph,
  SearchInput
} from '@eggplant/pattern-library'
import type { FormEvent } from 'react'
import type { Placement } from '@eggplant/types'

interface Props {
  isDisabled?: boolean
  value: number
  onChange: (event: FormEvent) => void
  onClear: () => void
  minInputFieldType?: number
  maxInputFieldType?: number
  placement?: Placement
  trailingLabel: string
}

const InputTime = ({
  isDisabled,
  minInputFieldType,
  maxInputFieldType,
  onClear,
  onChange,
  placement = 'left',
  trailingLabel,
  value
}: Props) =>
  <SearchInput
    fieldType='number'
    hasSearchIcon={false}
    isDisabled={isDisabled}
    max={maxInputFieldType}
    min={minInputFieldType}
    onChange={onChange}
    onClear={onClear}
    placeholder='0'
    placement={placement}
    trailingLabel={
      <Paragraph>
        <Color variant='theme-placeholder-text'>
          {trailingLabel}
        </Color>
      </Paragraph>
    }
    value={value.toString() || ''}
  />

export default InputTime
